export enum ServiceOfferingEnums {
    CHEFIT = "CHEFIT",
    SUBSCRIPTION = "SUBSCRIPTION",
    PARTY = "PARTY",
    ROYALE = "ROYALE",
}
